import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const LogisticsMaterialList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [logisticsMaterialList, setLogisticsMaterialList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) =>
							history.push(`/logistics/material/update/${record.id}`)
						}
					/>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getLogisticsMaterialList();
	}, []);

	const getLogisticsMaterialList = async () => {
		setLoading(true);

		const url = api + "/logistics/material/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
					});
				});
				setLogisticsMaterialList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewLogisticsMaterial = () => {
		history.push("/logistics/material/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Button
					onClick={addNewLogisticsMaterial}
					type="primary"
					size="large"
					style={{
						width: 210,
					}}
					icon={<PlusCircleFilled />}
				>
					New Logistics Material
				</Button>
				<CustomTable
					columns={columns}
					data={logisticsMaterialList}
					isScroll={false}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Logistics Materials" description="Material List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default LogisticsMaterialList;
